import { render } from "./AudioField.vue?vue&type=template&id=3834a354"
import script from "./AudioField.vue?vue&type=script&lang=js"
export * from "./AudioField.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"AudioField.vue"]])

export default __exports__